export const ILISKI_MEDIHA = [
  {
    id: "im001",
    metin: "{{ad}}, bu iki yüze baktım ve içim sıkıştı biraz. {{soru}} konusunda asıl mesele yüzeyde değil — derinlerde bir şeyler var. Aşk var, evet. Ama aşkın altında ne var? Saygı mı, güven mi, gerçek bir bağ mı? Bunları sormak zor ama gerekli.\n\nO derine inme cesaretini bulun. Yüzeyde kalmak ilişkiyi korumaz, sadece erteler. Derine inip orada çalışmak — işte o ilişkiyi yaşatır.",
    tema: "derinlik"
  },
  {
    id: "im002",
    metin: "{{ad}}, bu ilişkiye baktım. {{soru}} konusunda şunu görüyorum: biri çok veriyor, öbürü çok alıyor. Bu denge sağlıklı değil ve uzun vadede veren tarafı tüketir.\n\nSınır koy. Sınır çizmek sevgisizlik değil, öz saygıdır. 'Bu kadar verebilirim' demek ilişkiyi zayıflatmaz — korur. Çünkü tükenen biri ilişkiye de veremez.",
    tema: "sinir"
  },
  {
    id: "im003",
    metin: "{{ad}}, bu iki insanın arasında köklü bir bağ var. {{soru}} konusunda bu bağ kolay kolay kopmaz — ama ihmal edilirse solar. Her canlı varlık gibi, bu bağ da beslenmeye ihtiyaç duyar.\n\nSulayın bu çiçeği — her gün biraz. Büyük jestler değil, küçük ama tutarlı özen. Bir 'seni düşündüm', bir dokunuş, bir 'bugün nasıldın?' Bunlar küçük görünür ama birikir.",
    tema: "bag"
  },
  {
    id: "im004",
    metin: "{{ad}}, bu ilişkide iletişim sorunu var — net görüyorum. {{soru}} konusunda söylenmesi gereken şeyler söylenmiyor. Bunlar birikiyor, katmanlaşıyor.\n\nBirikim zamanla patlama yapar. Konuşun — şimdi konuşun. Doğru an diye bir şey yoktur, doğru niyet vardır. Niyetiniz iyiyse, şimdi başlayın.",
    tema: "iletisim"
  },
  {
    id: "im005",
    metin: "{{ad}}, bu iki yüzün enerjisine baktım. {{soru}} konusunda biri sıcak, biri soğuk — biri ifade ediyor, biri içine atıyor. Bu zıtlık uyumsuzluk değil, farklı sevgi dilleri.\n\nBirbirinizin dilini öğrenin. Biri dokunuşla, biri sözle, biri eylemle sever. Hangi dili konuşuyorsunuz? O farkı anlamak, her şeyi değiştirir.",
    tema: "sevgi_dili"
  },
  {
    id: "im006",
    metin: "{{ad}}, bu ilişkide geçmişin ağırlığı var. {{soru}} konusunda eski yaralar kapanmadan yeni bölümler tam başlamıyor. O yara orada duruyor — görmezden geldikçe büyüyor.\n\nO yarayı sarın — birlikte. Eski kırgınlıkları konuşun, yargılamadan dinleyin. İyileşme için önce yüzleşmek gerekir. Zor ama gerekli.",
    tema: "iyilesme"
  },
  {
    id: "im007",
    metin: "{{ad}}, bu iki insana baktım — ikisi de gurur taşıyor. {{soru}} konusunda gurur ilişkilerin en büyük düşmanı olabilir. Kim önce uzanacak, kim ilk adımı atacak?\n\nO adımı atan güçsüz değil, güçlüdür. Çünkü gururu bir kenara bırakmak cesaret ister. Bugün o cesareti gösterin — pişman olmayacaksınız.",
    tema: "gurur"
  },
  {
    id: "im008",
    metin: "{{ad}}, bu ilişkide üçüncü bir enerji var — dış baskı. Aile mi, arkadaşlar mı, iş mi bilmiyorum. {{soru}} konusunda o dış etki ilişkiyi zorluyor.\n\nBuna karşı birlikte durun. Dışa karşı birlik, içe karşı dürüstlük — ilişkiyi bu ikisi korur. İlişkiniz sizin — başkalarının yorumlarına değil, birbirinize kulak verin.",
    tema: "dis_baski"
  },
  {
    id: "im009",
    metin: "{{ad}}, bu ilişkide güzel bir şey var — temel sağlam. {{soru}} ne olursa olsun, temeli sağlam olan ilişki fırtınayı atlatır.\n\nAma fırtına geçene kadar birlikte tutunmak lazım. Sallanmak normaldir — herkes sallanır. Önemli olan bırakmamak. Tutunun.",
    tema: "temel"
  },
  {
    id: "im010",
    metin: "{{ad}}, bu iki insanın arasında bir mesafe var — fiziksel değil, duygusal. {{soru}} konusunda o mesafeyi kapatan adımı kim atacak?\n\nKibri bir kenara bırak, önce sen at. Çünkü sen okuyorsun bu falı — sen ilk adımı atmaya hazırsın demek bu. Hazır olduğunda ilk adım zor görünmez.",
    tema: "mesafe"
  },
  {
    id: "im011",
    metin: "{{ad}}, bu ilişkide bir sır var — söylenmemiş bir şey. {{soru}} konusunda o sırrı taşımak yoruyor her ikisini de.\n\nSırlar ilişkilerin içini kemiriri. Doğru zamanda, doğru şekilde söyleyin. Söylenmesi zor olan şeyler genellikle söylenmesi en gerekli olanlardır.",
    tema: "sir"
  },
  {
    id: "im012",
    metin: "{{ad}}, bu iki yüze baktım ve güldüm içimden. Neden mi? Çünkü ikisi de aynı şeyi istiyor ama kimse söylemiyor. {{soru}} konusunda iletişim kurun.\n\nTelepati sadece filmlerde çalışır. Gerçek hayatta ihtiyaçlarınızı, isteklerinizi, beklentilerinizi söylemek zorundasınız. Söyleyin — duyulmak güzel hissettirir.",
    tema: "iletisim"
  },
  {
    id: "im013",
    metin: "{{ad}}, bu ilişkide dışarıdan gelen baskılar var. {{soru}} konusunda o baskılara karşı birlikte durabiliyorlar mı?\n\nDışarıya karşı birlik içeride güven yaratır. 'Biz birlikteyiz, ne olursa olsun' hissi — bu ilişkinin en güçlü temeli. O hissi birbirinize verin.",
    tema: "birlik"
  },
  {
    id: "im014",
    metin: "{{ad}}, bu ilişkiye baktım — iki farklı insan, iki farklı dünya. {{soru}} konusunda farklılıklar zenginlik mi yoksa engel mi?\n\nFarklılıkları kabul eden çiftler büyür. 'Sen benden farklısın ve bu güzel' diyebilmek — olgunluğun işareti. Farkı düşman değil, öğretmen yapın.",
    tema: "farklilik"
  },
  {
    id: "im015",
    metin: "{{ad}}, bu ilişkide aşk var — bunu net görüyorum. {{soru}} konusunda aşk tek başına yeterli mi?\n\nYetmez — ama aşkın olduğu yerde her şey çözülebilir, istenirse. 'İstiyoruz' sorusunun cevabı ne? O cevap her şeyi belirler.",
    tema: "ask"
  },
  {
    id: "im016",
    metin: "{{ad}}, bu iki insanın geçmişine baktım. {{soru}} konusunda geçmiş ilişkilerin gölgesi bu ilişkiye düşüyor.\n\nO gölgeden çıkmak lazım. Yeni ilişki, eski yaraların sargısı olamaz. Her ilişki kendine has bir şans hak eder — bu da öyle. Geçmişi bırakın, şimdiye odaklanın.",
    tema: "gecmis"
  },
  {
    id: "im017",
    metin: "{{ad}}, bu ilişkide kıskançlık var. {{soru}} konusunda kıskançlık sevginin değil, güvensizliğin göstergesi.\n\nO güvensizliğin kaynağını bulun. Dışarıda değil, içeride bakın. Kıskançlıkla ilişki beslenmez — yalnızca tükenir. Güven inşa edin, kontrol etmeyi bırakın.",
    tema: "kiskanclık"
  },
  {
    id: "im018",
    metin: "{{ad}}, bu iki yüze baktım — biri açık, biri kapalı. {{soru}} konusunda bu kapalılık ilişkiye zarar veriyor.\n\nKapalı olan neden kapalı? Bunu anlamak ilk adım. Yargılamadan sorun. Güvenli bir alan yaratın — o güvenli alanda kapalı olanlar açılır.",
    tema: "kapalilik"
  },
  {
    id: "im019",
    metin: "{{ad}}, bu ilişkide güzel anlar yaşanmış — bunu hissediyorum. {{soru}} konusunda o güzel anları hatırlayın.\n\nZor dönemde güzel anlar pusulangolur. 'Biz bunu birlikte yaşadık' demek, 'biz bunu birlikte aşabiliriz' demektir. O anları çıkarın arşivden, hatırlayın.",
    tema: "guzel_anlar"
  },
  {
    id: "im020",
    metin: "{{ad}}, bu ilişkideki güç dengesi beni düşündürdü. {{soru}} konusunda biri daha baskın, biri daha itaatkâr mı?\n\nSağlıklı ilişkide güç eşit paylaşılır. Bu dengeyi gözden geçirin — şikâyet etmeden, suçlamadan. 'Ben şunu hissediyorum' diye başlayan cümleler daha az savunmacılık yaratır.",
    tema: "guc_dengesi"
  },
  {
    id: "im021",
    metin: "{{ad}}, bu ilişkide büyüme var — ikisi de birbirinden öğreniyor. {{soru}} konusunda bu öğrenme süreci zaman alır.\n\nSabırsızlanmayın. Her ilişki kendi ritmiyle gelişir. Karşınızdakinin gelişimine alan tanıyın — ve sizin gelişiminize de alan isteyin. Büyüme tek taraflı olmaz.",
    tema: "buyume"
  },
  {
    id: "im022",
    metin: "{{ad}}, bu iki insanın arasındaki sessizliklere baktım. {{soru}} konusunda o sessizliklerde ne var? Huzur mu, gerginlik mi?\n\nHuzurlu sessizlik derin bağın işareti. Gergin sessizlik ise konuşulması gereken şeylerin biriktiği bir depo. Hangisi? Buna göre adım atın.",
    tema: "sessizlik"
  },
  {
    id: "im023",
    metin: "{{ad}}, bu ilişkide affetme meselesi var. {{soru}} konusunda biri affetmek zorunda — belki ikisi de.\n\nAffetmek unutmak değil, ilerlemeyi seçmektir. Ve bazen özür beklenmeden affedilir — kendi huzurunuz için. O yük her ikisini de ağır bastırıyor. Bırakın onu.",
    tema: "affetme"
  },
  {
    id: "im024",
    metin: "{{ad}}, bu ilişkiye baktım ve şunu gördüm: iki insan da yorulmuş — birbirinden değil, mücadeleden. {{soru}} konusunda mücadeleyi bırakın.\n\nBirbirinize karşı değil, birlikte mücadele edin. Hedef ortak olsun — sorun değil, çözüm odağı. 'Biz bunu nasıl çözeriz?' sorusu her şeyi değiştirir.",
    tema: "yorgunluk"
  },
  {
    id: "im025",
    metin: "{{ad}}, şunu söyleyeyim: bu ilişki değerli. {{soru}} ne olursa olsun, değerli olan şeyi korumak için çaba göstermek gerekir.\n\nKolay olan kaçmak, zor olan kalmak ve çalışmaktır. Ama zor olan daha değerlidir. Çünkü emekle büyüyen şeyler, kolaylıkla gelenlerden çok daha uzun süre dayanır.",
    tema: "deger"
  }
];